/**
 * @file _view/_sp-menu-button.js
 */
(function ($) {
	'use strict';

	/**
	 *
	 * @namespace SpMenuButton
	 * @constructor
	 * @classdesc sp menu button
	 * @param {jQuery} $e - 対象となる jQuery オブジェクト
	 */
	var SpMenuButton = function ($e) {
		this._$e = $e;
		this._$e.on('click', this.showMenu.bind(this));
		this._$close = $('.js-sp-menu-close');
		this._$close.on('click', this.hideMenu.bind(this));
	};


	/**
	 *
	 * memberof SpMenuButton
	 * @const {string}
	 */
	SpMenuButton._classname = 'SpMenuButton';


	/**
	 * sp menu open
	 *
	 * @memberof SpMenuButton
	 * @return {undefined}
	 */
	SpMenuButton.prototype.showMenu = function () {
		$('.drawer').addClass('drawer--active');
	};


	/**
	 * sp menu close
	 *
	 * @memberOf SpMenuButton
	 * @return {undefined}
	 */
	SpMenuButton.prototype.hideMenu = function () {
		$('.drawer').removeClass('drawer--active');
	};

	module.exports = SpMenuButton;
})(jQuery);